import { Box, Button, CircularProgress } from '@mui/material';
import React from 'react';

interface IProps {
  isPending: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset' | undefined;
  variant?: 'contained' | 'outlined';
  label?: string;
}

export const SaveButton: React.FC<IProps> = ({
  isPending,
  onClick,
  type,
  variant,
  label,
}) => {
  const btnLabel = label ? label : 'Speichern';

  return (
    <Button
      variant={variant ? variant : 'contained'}
      type={type}
      disabled={isPending}
      onClick={onClick}
    >
      {isPending ? (
        <Box display='flex' alignItems='center' gap={1}>
          <span>{btnLabel}</span>
          <CircularProgress size={20} />
        </Box>
      ) : (
        <>{btnLabel} </>
      )}
    </Button>
  );
};
